<div class="d-inline-block" display="dynamic" container="body">
    <button class="btn btn-outline-dark btn-sm position-relative " type="button" data-toggle="modal" [attr.data-target]="'#filtromagicoModal' + id">
        <i class='fas fa-filter'></i>
        <span *ngIf="cantidadFiltrosSeleccionados > 0" class="badge badge-pill badge-danger badge-notify">
            {{cantidadFiltrosSeleccionados}}
        </span>
    </button>
</div>

<div class="modal fade" [attr.id]="'filtromagicoModal' + id" tabindex="-1" role="dialog" aria-labelledby="filtromagicoModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="filtromagicoModalLabel">Filtros</h5>
                <button type="button" class="close" data-toggle="modal" [attr.data-target]="'#filtromagicoModal' + id" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-filtro-magico
                    [id]="id"
                    [filtros]="datatable.filtrosMagicos"
                    (onFiltrosCambiados)="filtrosCambiados($event)">
                </app-filtro-magico>
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onBotonFiltrar()">Filtrar</button> -->
                <button type="button" class="btn btn-secondary" data-toggle="modal" [attr.data-target]="'#filtromagicoModal' + id" (click)="close();">Cerrar</button>
            </div>
        </div>
    </div>
</div>
